module.exports = __webpack_public_path__ + "img/48.20d1ce26.gif";